import * as React from 'react';

const classNames = require('classnames');

interface Props {
	name: string;
	type?: string;
	placeholder?: string;
	value?: string | number;
	onChange?: (value?: {}) => void;
	onKeyDown?: (e?: any) => void;
	onKeyPress?: (e?: any) => void;
	onKeyUp?: (value?: any) => void;
	onBlur?: (e?: any) => void;
	defaultValue?: string;
	className?: string;
	min?: number;
	step?: number;
	maxlength?: number;
}

const TextInput: React.StatelessComponent<Props> = props => {
	return (
		<input
			{...props}
			type={props.type ? props.type : 'text'}
			className={classNames('form-control form-table-control', props.className)}
		/>
	);
};

export default TextInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/TableTextInput.tsx